import HtmlElement from './HtmlElement';
import {Settings} from '../Settings';
import {$window, $body} from '../Constants';
import Header from './Header';

/**
 * Contact Button
 */
class ContactButton extends HtmlElement {
    onReady() {
        this.$text = this.$element.find('span');
        this.isScrolled = false;
        this.scrollAmount = Header.getHeight();

        this.checkScrolled();
    }

    onScroll() {
        this.checkScrolled();
    }

    hideText() {
        this.$text.fadeOut(500, () => {
            this.$element.css('width', 56);
        });
    }

    showText() {
        this.$element.css('width', 213);

        setTimeout(() => {
            this.$text.fadeIn(500);
        }, 300);
    }

    checkScrolled() {
        let top = $window.scrollTop();

        if(!this.isScrolled) {
            if(top > this.scrollAmount) {
                this.$element.addClass('scrolled');
                this.isScrolled = true;
            }
        }else {
            if(top <= this.scrollAmount || top + $window.height() >= $(document).height()) {
                this.$element.removeClass('scrolled');
                this.isScrolled = false;
            }
        }
    }
}

export default (new ContactButton($body.find('.contactButton')));